import { render } from "./CreatorsPage.vue?vue&type=template&id=06dbf1af&ts=true"
import script from "./CreatorsPage.vue?vue&type=script&lang=ts"
export * from "./CreatorsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__